import { gestureKeys } from './constants'

import { createEventEmitter } from '../event'

export const gestureEventEmitter = createEventEmitter()
export const controlBarGestureEventEmitter = createEventEmitter()

export const emitGestureMsg = msg => {
    gestureEventEmitter.emit(gestureKeys.GESTURE_MSG, msg)
}

export const emitRevertGestureMsg = msg => {
    gestureEventEmitter.emit(gestureKeys.REVERT_GESTURE_MSG, msg)
}

export const emitControlBarGestureMsg = msg => {
    controlBarGestureEventEmitter.emit(gestureKeys.CONTROL_BAR_GESTURE, msg)
}

export const emitHotKeyGestureMsg = msg => {
    controlBarGestureEventEmitter.emit(gestureKeys.HOTKEY_GESTURE, msg)
}

export const emitTeacherAcknowledgement = msg => {
    controlBarGestureEventEmitter.emit(gestureKeys.TEACHER_ACKNOWLEDGEMENT, msg)
}
